var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pa-2 rounded-sm my-4",staticStyle:{"border":"solid 1px #e0e0e0"}},[_c('div',{attrs:{"id":"matomo-opt-out"}})])}]

export { render, staticRenderFns }